<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-overlay(:value="saving || companyTypesFetching" absolute)
                v-progress-circular(indeterminate size="64")
            v-card-title.title.caption--text {{title}}
            v-container(tag="v-card-text" gris-list-lg)
                v-form(id="form" ref="refForm" @submit.prevent="onSubmit")
                    v-layout(wrap)
                        v-flex(xs12)
                            v-text-field(v-model="code"
                                ref="refCode"
                                counter=10
                                :rules="[rules.required, rules.maxLength(code, 10)]"
                                :label="$t('pages.settings.company.table.headers.code.title')")
                        v-flex(xs12)
                            v-text-field(v-model="name"
                                counter=100
                                :rules="[rules.required, rules.maxLength(name, 100)]"
                                :label="$t('pages.settings.company.table.headers.name.title')")
                        v-flex(xs12)
                            v-select(v-model="types" :rules="[rules.required]" chips multiple
                            :items="companyTypes"
                                :label="$t('pages.settings.company.table.headers.type.title')")
                        v-flex(xs12)
                            v-radio-group(v-model="status" :mandatory="false" row)
                                v-radio(:label="$t(`pages.settings.company.table.headers.status.values.false`)" color="red" :value="false")
                                v-radio(:label="$t(`pages.settings.company.table.headers.status.values.true`)" color="green" :value="true")
                                template(#prepend)
                                    .body-1 {{$t('pages.settings.company.table.headers.status.title')}}
                        v-flex(xs12)
                            .body-1 {{$t('pages.settings.company.labels.logo.title')}}
                            v-layout(justify-center align-center column)
                                input(type="file" style="display: none;" accept="image/*" ref='file' @change="onFilePicked")
                                v-hover(v-if="logo")
                                    template(#default="{hover}")
                                        v-img(:src="logo" max-height="200" max-width="200" lazy-src="require(`../../assets/logo.png`)").ma-2.elevation-3
                                            template(#placeholder)
                                                v-layout(fill-height align-center justify-center ma-0)
                                                    v-progress-circular(indeterminate color="grey lighten-5")
                                            v-fade-transition
                                                v-overlay(v-if="hover" absolute color="#036358")
                                                    v-btn(color="error" @click="removeImage")
                                                        v-icon(left) mdi-delete
                                                        span {{$t('general.remove')}}
                                v-btn(color="button" depressed @click="onPickFile" :loading="imageUploading").white--text
                                    v-icon(left dark) mdi-cloud-upload
                                    | {{$t('general.uploadImage')}}
                        v-flex(xs12)
                            v-select(v-model="theme" :rules="[rules.required]"
                                :items="companyColorThemes"
                                :label="$t('pages.settings.company.labels.theme.title')")
                                template(#item="{ item }")
                                    v-list-item-action
                                        v-avatar(size="30" tile :color="item.color.primary")
                                            span(class="title font-weight-medium white--text") {{ item.text.charAt(0) }}
                                    v-list-item-content
                                        v-list-item-title(v-text="item.text")
                                template(#selection="{ item, selected }")
                                    v-avatar(size="25" tile :color="item.color.primary")
                                        span(class="body-2 font-weight-medium white--text") {{ item.text.charAt(0) }}
                                    span.mx-2 {{item.text}}
            v-layout(tag="v-card-actions")
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(type="submit" form="form" color="primary" depressed :loading="imageUploading").px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.save')}}
</template>

<script>
import rules from "../../mixins/rules";
import general from "../../mixins/general";
import crud from "../../mixins/crud";

const URL = window.URL || window.webkitURL;

export default {
  name: "EditDialog",
  mixins: [rules, general, crud],
  data() {
    return {
      mode: "create",
      dialog: false,
      code: null,
      name: null,
      type: null,
      types: [],
      status: true,
      theme: null,
      logo: null,
      file: null,
      media_id: null,
      current_id: null,
      saving: false,
      imageUploading: false,
      cancelUpload: null
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    },
    title: {
      get() {
        return this.$t(`pages.settings.company.dialog.title.${this.mode}`);
      }
    }
  },
  methods: {
    clear() {
      this.code = null;
      this.name = null;
      this.type = null;
      this.types = [];
      this.status = true;
      this.theme = null;
      this.logo = null;
      this.file = null;
      this.media_id = null;
      this.current_id = null;
      this.imageUploading = false;
      this.cancelUpload = null;
    },
    show(mode, data = null) {
      this.mode = mode;
      this.dialog = true;
      if (mode === "create") this.fetchCompanyTypes(undefined);
      this.$nextTick(() => {
        this.$refs.refForm.reset();
        this.$nextTick(() => {
          this.clear();
          if (mode === "edit" && data) {
            this.fetchCompanyTypes(undefined).then(items => {
              if (Array.isArray(data.types) && Array.isArray(items)) {
                const newTypes = items
                  .filter(
                    ({ name, status }) => status && data.types.includes(name)
                  )
                  .map(({ name }) => name);
                this.types = newTypes;
              }
            });

            this.code = data.code;
            this.name = data.name;
            this.type = data.type;
            // this.types = data.types;
            this.status = data.status;
            this.theme = data.theme;
            this.logo = data.image;
            this.media_id = data.media_id;
            this.current_id = data.code;
          }
        });
        if (this.$vuetify.breakpoint.mdAndUp && this.$refs.refCode) {
          this.$refs.refCode.focus();
        }
      });
    },
    close() {
      if (this.imageUploading && typeof this.cancelUpload === "function")
        this.cancelUpload(this.$t("general.cancelUploadImageByUser"));
      this.dialog = false;
      // this.$nextTick(() => {
      //   this.clear();
      // });
    },
    onSubmit() {
      if (!this.imageUploading && this.$refs.refForm.validate()) {
        this.$confirm(this.$t("messages.saveConfirmation")).then(value => {
          if (value) {
            this.saving = true;
            setTimeout(() => {
              const data = {
                code: this.code,
                name: this.name,
                type: this.type,
                types: this.types,
                status: this.status,
                theme: this.theme,
                logo: this.logo,
                media_id: this.media_id
              };

              this.axios({
                url:
                  this.mode === "create"
                    ? `companies`
                    : `companies/${encodeURIComponent(this.current_id)}`,
                method: this.mode === "create" ? `post` : `put`,
                data
              })
                .then(response => {
                  this.saving = false;
                  this.close();
                  this.$emit("saved", response.data.data);
                })
                .catch(error => {
                  this.saving = false;
                  if (this.mode === "create") this.saveErrorHandler(error);
                  else this.updateErrorHandler(error);
                });
            }, 500);
          }
        });
      }
    },
    onPickFile() {
      this.$refs.file.click();
    },
    onFilePicked(e) {
      this.readImage(e)
        .then(image => {
          let self = this;

          const data = new FormData();
          data.append("image", image.file);

          this.imageUploading = true;
          this.axios
            .post(`upload-image`, data, {
              cancelToken: new this.axios.CancelToken(function executor(c) {
                self.cancelUpload = c;
              })
            })
            .then(response => {
              const image = response.data.data;
              this.imageUploading = false;
              this.logo = image.url;
              this.media_id = image.id;
            })
            .catch(error => {
              this.imageUploading = false;
              if (this.axios.isCancel(error)) {
                this.$toasted.error(error.message, { icon: "mood_bad" });
              } else {
                this.saveErrorHandler(error);
              }
            });
        })
        .catch(e => {
          window.alert(e && e.message ? e.message : e);
        })
        .finally(() => {
          e.target.value = "";
        });
    },
    readImage({ target }) {
      const files = target.files;
      return new Promise((resolve, reject) => {
        if (!files || files.length === 0) {
          resolve();
          return;
        }
        const file = files[0];
        if (/^image\/\w+$/.test(file.type)) {
          if (URL) {
            resolve({
              loaded: true,
              name: file.name,
              type: file.type,
              url: URL.createObjectURL(file),
              file: file
            });
          } else {
            reject(new Error("Your browser is not supported."));
          }
        } else {
          reject(new Error("Please choose an image file."));
        }
      });
    },
    removeImage() {
      this.logo = null;
      this.media_id = null;
    }
  }
};
</script>
